import React from "react";

const CallToAction = () => (
  <section className="w-full bg-dark-1 py-16 px-6 text-center text-white">
    <h3 className="text-title font-bold mb-6">
      Devenir tuteur, ce n’est pas seulement enseigner.  
      C’est <span className="text-green-1">faire partie d’un mouvement</span> qui change la manière d’apprendre.
    </h3>
    <p className="mb-8 text-light-3">
      Tu as des compétences ? Tu as de la passion ? Alors tu as déjà ce qu’il faut pour nous rejoindre.
    </p>
    <div className="flex flex-col sm:flex-row justify-center gap-4">
      <a
        href="/candidature"
        className="border-2 border-blue-1 bg-blue-1 text-white py-3 px-8 rounded-full text-button hover:bg-white hover:text-blue-1 transition"
      >
        Proposer ma candidature
      </a>
      <a
        href="/role-tuteur"
        className="border-2 border-red-4 bg-red-4 text-white py-3 px-8 rounded-full text-button hover:bg-white hover:text-red-4 transition"
      >
        En savoir plus
      </a>
    </div>
  </section>
);

export default CallToAction;
